import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { Tooltip as ReactTooltip } from "react-tooltip";
import "./assets/style.css";
import { auth, db } from "./firebase";
import firebase from "firebase/compat/app";
import { Element, scroller } from "react-scroll";

const Chapter2_1 = () => {
  const navigate = useNavigate();
  const [selectedAnswers, setSelectedAnswers] = useState({ q1: "", q2: "" });
  const [error, setError] = useState("");
  const [userId, setUserId] = useState(null);

  const questions = [
    {
      question:
        "Frage 1: Warum kann die unregelmäßige Aktualisierung von Software, insbesondere nach bereits bekannten Schwachstellen zu einem erhöhtem Sicherheitsrisiko führen?",
      options: [
        {
          value: "A",
          label:
            "Wenn Software nicht regelmäßig aktualisiert wird, bleiben bekannte Schwachstellen bestehen, die Angreifer leicht ausnutzen können, um unbefugten Zugang zu erlangen oder Schaden anzurichten",
        },
        {
          value: "B",
          label:
            "Erst die Aktualisierung ermöglicht es den Angreifern Attacken auszuführen.",
        },
      ],
      correct: "A",
    },
    {
      question:
        "Frage 2: Welche Rolle spielt Penetration Testing (Pen-Testing) in der Erkennung von Sicherheitslücken?",
      options: [
        {
          value: "A",
          label:
            "Penetration Testing simuliert gezielte Angriffe auf Systeme, um Schwachstellen zu entdecken, die über einfache Scans hinausgehen, einschließlich unkonventioneller und kreativer Angriffsmethoden",
        },
        {
          value: "B",
          label:
            "Penetration Testing ist ein automatisierter Prozess, der bekannte Schwachstellen identifiziert, ohne dass menschliches Expertenwissen genutzt wird.",
        },
      ],
      correct: "A",
    },
  ];

  const location = useLocation(); 

  
  useEffect(() => {
    if (location.hash) {
      scroller.scrollTo(location.hash.substring(1), {
        duration: 500,
        smooth: true,
        offset: -50,
      });
    }
  }, [location]);

  
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUserId(user.uid); 
      } else {
        console.error("Kein authentifizierter Benutzer gefunden");
        setError("Benutzer ist nicht authentifiziert");
        navigate("/login"); 
      }
    });

   
    return () => unsubscribe();
  }, [navigate]);

  
  useEffect(() => {
    console.log("Aktuelle userId in 2_1.js:", userId);
  }, [userId]);

  const handleLogout = () => {
    
    auth
      .signOut()
      .then(() => {
        
        window.location.href = "/login"; 
      })
      .catch((error) => {
        console.error("Logout fehlgeschlagen:", error);
      });
  };

  const handleAnswerChange = (questionIndex, value) => {
    setSelectedAnswers((prev) => ({
      ...prev,
      [questionIndex]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const correctAnswers = questions.every(
      (q, index) => selectedAnswers[index] === q.correct
    );

    if (correctAnswers) {
      try {
        if (!userId) {
          console.error("userId ist nicht definiert");
          setError("Ein Fehler ist aufgetreten.");
          return;
        }

        
        const userDoc = await db.collection("users").doc(userId).get();

        console.log("userDoc:", userDoc.exists); 

        if (userDoc.exists) {
          
          await db
            .collection("users")
            .doc(userId)
            .update({
              lastChapter: "2_1",
              completedChapters:
                firebase.firestore.FieldValue.arrayUnion("2_1"),
            });
          console.log("Dokument aktualisiert mit Kapitel 2_1.");
        } else {
          
          await db
            .collection("users")
            .doc(userId)
            .set({
              lastChapter: "2_1",
              completedChapters: ["2_1"],
            });
          console.log("Dokument erstellt mit Kapitel 2_1");
        }

        navigate("/2_2"); 
      } catch (error) {
        console.error("Fehler beim Aktualisieren des Fortschritts:", error);
        setError("Ein Fehler ist aufgetreten. Versuche es später erneut.");
      }
    } else {
      setError("Die Antworten sind nicht korrekt. Versuche es erneut.");
    }
  };
  return (
    <div className="container">
      <div className="container py-5">
        <img
          src="/images/zebbs_Logo.svg"
          class="d-block mx-auto mb-4"
          alt=""
          style={{ width: "20%" }}
        />
        <div className="d-flex justify-content-between align-items-center mb-5 p-3 bg-body-tertiary rounded-3">
          {/* Breadcrumbs */}
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb breadcrumb-chevron mb-0">
              {/* Startseite (Home) */}
              <li className="breadcrumb-item">
                <Link className="link-body-emphasis" to="/course-overview">
                  <i className="bi bi-house-door-fill"></i>
                  <span className="visually-hidden">Home</span>
                </Link>
              </li>

              {/* Library Link */}
              <li className="breadcrumb-item">
                <Link
                  className="link-body-emphasis fw-semibold text-decoration-none"
                  to="/course-overview"
                >
                  2. Sicherheitslücken und Schwachstellen
                </Link>
              </li>

              {/* Aktuelle Seite */}
              <li className="breadcrumb-item active" aria-current="page">
                Was sind Schwachstellen?
              </li>
            </ol>
          </nav>

          {/* Logout-Button */}
          <button className="btn btn-outline-dark" onClick={handleLogout}>
            Logout
          </button>
        </div>

        <div
          className="p-5 m-0 rounded-3"
          style={{
            position: "relative",
            backgroundColor: "#009fe0",
            margin: "25px",
            textAlign: "center",
          }}
        >
          <h3 className="text-center p-3">
            Kapitel 2: Sicherheitslücken und Schwachstellen
          </h3>
          <h2 className="text-center p-3">Was sind Schwachstellen?</h2>
          <img
            src="./images/sicherheitsluecke.webp"
            alt="Sicherheitsluecke"
            style={{ position: "relative", maxWidth: "25%", height: "auto" }}
          />
        </div>

        <div className="chapter p-5 text-center">
          <h2 className="p-5">Warum sind Angriffe überhaupt möglich?</h2>
          <p className="col-lg-11 mx-auto">
            Sicherheitslücken und Schwachstellen sind Schwachpunkte{" "}
            <strong> (Vulnerabilities) </strong>in Computersystemen, Anwendungen
            oder Netzwerken, die es Angreifern ermöglichen, unbefugt Zugriff zu
            erlangen, Daten zu stehlen oder Schaden anzurichten.
            <br />
            <br /> Sie können in Hardware, Software oder Prozessen existieren
            und entstehen häufig durch Programmierfehler, Fehlkonfigurationen
            oder unzureichende Sicherheitsmaßnahmen.
            <br />
            <br /> Um sie zu minimieren, ist es wichtig zu verstehen, wie sie
            entstehen und welche Maßnahmen ergriffen werden können.
          </p>

          <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
            <img
              src="/images/fact.svg"
              alt="Transparent"
              style={{
                position: "relative",
                maxWidth: "8%",
                height: "auto",
              }}
            />
            Der Verizon Data Breach Investigations Report 2024 zeigt einen
            drastische Anstieg der Ausnutzung von Schwachstellen als Ursache für
            Sicherheits­verletzungen, der im Vergleich zum Vorjahr um 180
            Prozent gestiegen ist. Diese Entwicklung verdeutlicht die
            Notwendigkeit effektiver Schwachstellenmanagement-Strategien.
          </p>
        </div>
      </div>

      <div className="grey-section">
        <div className="container">
          <div className="p-5 text-center">
            <h3 className="p-5">
              Ursachen von Sicherheitslücken und Schwachstellen:
            </h3>

            <h4 className="pb-5">Programmierfehler und Bugs</h4>
            <p className="col-lg-11 mx-auto">
              Fehler im Code einer Anwendung oder eines Systems können zu
              Sicherheitslücken führen. Beispielsweise können schlecht
              programmierte Funktionen oder Apps ungewollte Zugänge schaffen,
              die von Angreifern genutzt werden können.
            </p>

           

              <p className="col-lg-11 mx-auto">
                Softwareentwickler sollten daher von Anfang an
                Sicherheitsaspekte <strong> (Secure Coding Practices) </strong>{" "}
                in ihren Code integrieren. Durch das Befolgen von Secure Coding
                Practices minimieren Entwickler Schwachstellen im Programmcode.
                <br />
                <br />
                <strong> Secure Coding Practices </strong> sind Techniken, die
                Entwickler anwenden, um Software sicher zu gestalten und
                Schwachstellen zu vermeiden. Dazu gehört, dass alle
                Benutzereingaben sorgfältig überprüft werden, um Angriffe zu
                verhindern. Ein einfaches Beispiel ist, dass durch eine
                <strong> Validierung</strong> direkt bei der Eingabe in
                Formularfeldern sichergestellt wird, dass die Daten den
                erwarteten Formaten entsprechen (z. B. dass eine Telefonnummer
                nur Zahlen enthält oder eine Mailadresse ein "@" enthält). Diese
                Überprüfung wird als fertige Java-Script-Funktion einfach in den
                Code integriert (z. B. die {" "}
                <span
                  data-tooltip-id="tooltip-bibliothek"
                  data-tooltip-content="Eine sichere Bibliothek ist eine Sammlung von vorgefertigtem Code mit Funktionen, die in einem Softwareprojekt verwendet wird und frei von bekannten Sicherheitslücken ist. Da Bibliotheken oft komplexe Funktionen bereitstellen, die wiederkehrende Aufgaben abdecken (z. B. Authentifizierung, Datenverschlüsselung, Netzwerkkommunikation), ist es wichtig, nur solche Bibliotheken zu verwenden, die aktuell und zuverlässig sind."
                  className="custom-tooltip-trigger"
                >
                  JavaScript-Bibliothek
                </span>{" "}

<span
                  data-tooltip-id="tooltip-validator"
                  data-tooltip-content="Die JavaScript-Bibliothek „validator“ dient dazu, Texteingaben automatisch zu überprüfen und auf formale Korrektheit zu testen. Sie erkennt zum Beispiel, ob eine eingegebene E-Mail-Adresse, URL oder IP-Adresse gültig ist und hilft so dabei, fehlerhafte oder manipulierte Eingaben frühzeitig abzufangen. Dadurch erhöht sie die Datenqualität und unterstützt die Sicherheit von Webanwendungen."
                  className="custom-tooltip-trigger"
                >
                  Validator.js
                </span>{" "}


                ).
                <br />
                <br />
             
                Auch die Verwendung sicherer und aktueller Bibliotheken ist
                entscheidend, da veraltete Bibliotheken Schwachstellen enthalten
                können. <br />
                <br />
                Nach dem Schreiben des Codes sollten regelmäßig
                Sicherheitsüberprüfungen und Updates durchgeführt werden, um
                potenzielle Risiken frühzeitig zu erkennen und zu beheben.
                Secure Coding Practices minimieren die Angriffsfläche und sorgen
                so dafür, dass Software von Anfang an sicherer ist.
              </p>
              <ReactTooltip
                id="tooltip-bibliothek"
                place="top"
                className="custom-tooltip"
              />
              <ReactTooltip
                id="tooltip-validator"
                place="top"
                className="custom-tooltip"
              />
           

            <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-beispiel rounded-2">
              <img
                src="/images/attack.svg"
                alt="Angriff"
                style={{
                  position: "relative",
                  maxWidth: "10%",
                  height: "auto",
                }}
              />
              Eine Zero-Day-Schwachstelle ist eine unbekannte Sicherheitslücke
              in einer Software, die Angreifer bereits ausnutzen, bevor der
              Softwarehersteller oder die Öffentlichkeit von dieser
              Schwachstelle erfährt. Das bedeutet, dass die Schwachstelle
              bereits existiert und aktiv genutzt wird. Aber niemand außer den
              Angreifern weiß davon. Da diese Schwachstelle unbekannt ist, gibt
              es keine Patches oder Schutzmaßnahmen. Die Entwickler haben "null
              Tage" Zeit, um eine Lösung bereitzustellen – daher der Name
              "Zero-Day".
            </p>
          </div>
        </div>
      </div>

      <div className="gelb-section">
        <div className="container">
          <div className="p-5 text-center">
            <h3 className="p-5">
              Ursachen von Sicherheitslücken und Schwachstellen:
            </h3>

            <h4 className="pb-5">Ungepatchte Software</h4>
            <p className="col-lg-11 mx-auto">
              Systeme und Programme, die nicht regelmäßig aktualisiert werden,
              sind anfällig für bereits bekannte Schwachstellen. Updates und Patches schließen
              die Sicherheitslücken, die ansonsten offen bleiben und ein Risiko
              darstellen.
              <br />
              <br />
              Eine der häufigsten und gefährlichsten Sicherheitslücken entsteht
              durch <strong>ungepatchte Software</strong>. Sicherheitsupdates
              (Patches) sind gezielte, kleinere Aktualisierungen oder
              Fehlerbehebungen, die spezifische Probleme oder Sicherheitslücken
              in einer Software beheben sollen, die im Laufe der Nutzung
              entdeckt wurden. Sie werden meist außerplanmäßig von
              Softwareherstellern veröffentlicht, um Sicherheitslücken zu
              schließen. Solche Lücken entstehen durch Programmierfehler,
              Fehlkonfigurationen oder schlicht durch den technologischen
              Fortschritt, der neue Bedrohungen mit sich bringt. Wenn diese
              Patches nicht installiert werden, bleibt die Schwachstelle
              bestehen. Das System wird anfällig für Angriffe. <br />
              <br />
              Trotz bekannter Risiken werden Patches oft vernachlässigt, weil
              deren Installation als störend oder zeitaufwendig betrachtet wird.
              Besonders in großen Unternehmen befürchten IT-Teams, dass kleinere
              Patches oder die großen Updates den laufenden Betrieb unterbrechen
              könnten oder Konflikte mit anderen Softwarelösungen verursachen
              könnten. Kleinere Organisationen ohne eigene IT-Abteilungen
              unterschätzen die Wichtigkeit regelmäßiger Updates und erkennen
              deren Notwendigkeit erst nach einem Sicherheitsvorfall.
            </p>

           

              <p className="col-lg-11 mx-auto">
                <Element name="patch">
                  Ein automatisches Patch-Management-System kann dafür sorgen,
                  dass Patches automatisch auf Computern, Servern und anderen
                  Geräten installiert werden, ohne dass ein manuelles Eingreifen
                  erforderlich ist. Solche Systeme scannen regelmäßig nach neuen
                  Patches, laden diese herunter und installieren sie auf den
                  relevanten Systemen. <br />
                  <br />
                  Dadurch können bekannte Sicherheitslücken geschlossen,
                  menschliche Fehler minimiert und IT-Teams entlastet werden.
                  Automatisierte Prozesse ermöglichen es, Updates gezielt zu
                  planen – z. B. außerhalb der Geschäftszeiten – und garantieren
                  eine konsistente Sicherheit über alle Geräte hinweg. Zudem
                  unterstützen detaillierte Berichte die Einhaltung von
                  Compliance-Anforderungen. Trotz der Automatisierung erfordert
                  ein effektives Patchmanagement eine regelmäßige Überwachung,
                  eine klare Priorisierung und einen Notfallplan, um potenzielle
                  Komplikationen zu minimieren. Tools wie Microsoft WSUS, IBM
                  BigFix oder ManageEngine Patch Manager Plus bieten Unternehmen
                  umfassende Lösungen für ein zuverlässiges und skalierbares
                  Patchmanagement.
                </Element>
              </p>
           
            <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-beispiel rounded-2">
              <img
                src="/images/attack.svg"
                alt="Angriff"
                style={{
                  position: "relative",
                  maxWidth: "10%",
                  height: "auto",
                }}
              />
              Ein Beispiel ist der Angriff auf die E-Mail-Server-Software SmarterMail des Unternehmens SmarterTools Anfang 2026. Angreifer nutzten eine nicht installierte Sicherheitsaktualisierung aus, um sich Zugang zu einem Server zu verschaffen und anschließend Schadsoftware zu platzieren. SmarterTools hat selbst beschrieben, dass der Einstieg über eine einzelne, „vergessene“ virtuelle Maschine erfolgte, die nicht in den Update-Prozess eingebunden war – also genau das typische Patch-Problem. (techradar.com, Feb. 2026)
            </p>
          </div>
        </div>
      </div>

      <div className="weiß-section">
        <div className="container">




          <div className="p-5 text-center">

            <p className="col-lg-11 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
            <img
              src="/images/fact.svg"
              alt="Transparent"
              style={{
                position: "relative",
                maxWidth: "8%",
                height: "auto",
              }}
            />
            Laut dem IBM X-Force Threat Intelligence Index 2025 entfielen 30 % der von X-Force in 2024 bearbeiteten Vorfälle auf die Ausnutzung von Schwachstellen in öffentlich erreichbaren Anwendungen – ein typischer Effekt von fehlendem oder verspätetem Patchen. In kritischer Infrastruktur lag dieser Anteil bei 26 %. (IBM X-Force Threat Intelligence Index 2025)
          </p>
            <h5 className="p-5">
              Auf weitere Ursachen von Sicherheitslücken und Schwachstellen
              werden wir in den folgenden Kapiteln eingehen. <br />
              <br /> <br />
            
            </h5>
          </div>
        </div>
      </div>

 










      <div className="container">
        <div
          className="safe rounded-2 text-center"
          style={{ backgroundColor: "#fec748" }}
        >
          <img
            src="/images/abwehr.svg"
            alt="Abwehr"
            style={{
              position: "relative",
              maxWidth: "7%",
              height: "auto",
            }}
          />
          <h3 className="p-5">Best Practices zur Codeüberprüfung</h3>
          <p className="col-lg-11 mx-auto">
            Eine der effektivsten Maßnahmen zur Minimierung von
            Sicherheitslücken ist die Durchführung gründlicher Tests und
            regelmäßiger Codeüberprüfungen während der Entwicklung. Solche
            Prozesse gewährleisten, dass Schwachstellen frühzeitig erkannt und
            behoben werden, bevor die Software in Produktion geht.
            <br />
            <br />
            <strong> Code Reviews </strong> (regelmäßige Codeüberprüfungen)
            dienen dazu, Fehler oder potenzielle Schwachstellen zu erkennen,
            bevor der Code live geschaltet wird. Entwickler prüfen den Code von
            Kollegen und geben Feedback, um sowohl funktionale als auch
            sicherheitsrelevante Probleme aufzudecken. Code-Reviews können
            manuell oder automatisiert mithilfe von Tools wie SonarQube oder
            Checkmarx durchgeführt werden.
            <br />
            <br />
            Die <strong> statische Codeanalyse </strong> überprüft den
            Quellcode, ohne die Software auszuführen. Sie identifiziert
            potenzielle Schwachstellen wie unsichere Datenverarbeitung oder
            fehlende Eingabevalidierung.
            <br />
            <br />
            Die <strong> dynamische Codeanalyse </strong> überprüft den Code
            während er ausgeführt wird, um Schwachstellen in der
            Laufzeitumgebung zu erkennen, wie z. B. ungesicherte
            API-Schnittstellen oder anfällige Netzwerkanfragen.
            <br />
            <br />
            <Element name="pentest">
              In <strong> Penetrationstests </strong> simulieren
              Sicherheitsexperten reale Angriffe, um Schwachstellen in der
              Software zu finden. Penetrationstests helfen, Sicherheitsprobleme
              zu identifizieren, die in Codeüberprüfungen oder anderen Tests
              übersehen wurden. Der Ablauf beginnt mit der Planungs- und
              Aufklärungsphase, in der die Ziele des Tests definiert und
              Informationen über die Zielsysteme gesammelt werden,
              beispielsweise durch öffentliche Datenquellen oder Netzwerk-Scans.
              Anschließend folgt die Scan- und Analysephase, in der
              Schwachstellen durch automatisierte Tools und manuelle Techniken
              identifiziert und bewertet werden. In der Angriffsphase versucht
              der Tester, die gefundenen Schwachstellen aktiv auszunutzen, um
              Zugriff auf sensible Daten oder Systeme zu erhalten. Danach folgt
              die Post-Exploitation-Phase, in der analysiert wird, welche
              Informationen zugänglich waren und wie tief das System
              kompromittiert werden konnte. Abschließend wird in der
              Berichtsphase eine detaillierte Dokumentation erstellt, die alle
              identifizierten Schwachstellen, erfolgreiche Angriffspunkte und
              Empfehlungen zur Behebung der Sicherheitslücken enthält.
            </Element>
            <br />
            <br />
            <Element name="vulne">
              <strong> Vulnerability-Scans </strong> identifizieren bekannte
              Sicherheitslücken in der Software oder der Infrastruktur. Tools
              wie das kommerzielle Nessus oder der
              Open-Source-Vulnerability-Scanner OpenVAS automatisieren diesen
              Prozess und liefern Berichte, die Entwicklern helfen, gezielt
              Verbesserungen vorzunehmen. Vulnerability-Scans beginnen mit der
              Informationssammlung, bei der Daten zu IP-Adressen,
              Betriebssystemen und offenen Ports der Zielsysteme erfasst werden.
              Anschließend folgt die Schwachstellenanalyse, bei der die Systeme
              auf bekannte Sicherheitslücken und Fehlkonfigurationen geprüft
              werden. Die gefundenen Schwachstellen werden in der
              Risiko-Bewertung nach ihrer Kritikalität eingestuft – von niedrig
              bis kritisch. Abschließend erstellt der Scanner einen Bericht, der
              die identifizierten Schwachstellen dokumentiert, ihre potenziellen
              Risiken bewertet und konkrete Handlungsempfehlungen zur Behebung
              liefert.
              <br />
              <br /> Es gibt verschiedene Arten von Vulnerability-Scans:
              <br />
              <strong> Interne Scans </strong> analysieren Systeme innerhalb des
              Netzwerks, während <strong> externe Scans </strong> die
              Angriffsflächen von außen simulieren.{" "}
              <strong> Authentifizierte Scans </strong> nutzen Zugangsdaten für
              tiefere Analysen, während
              <strong> nicht-authentifizierte Scans </strong> nur öffentlich
              zugängliche Informationen prüfen. Zusammen ermöglichen diese
              Methoden eine umfassende Sicherheitsbewertung von IT-Systemen.
              <br />
              <br />
              Alle Tests und Codeüberprüfungen sollten dokumentiert werden, um
              Transparenz zu schaffen und Schwachstellen nachzuverfolgen. Diese
              Dokumentation kann in zukünftigen Projekten helfen, ähnliche
              Fehler zu vermeiden.
            </Element>
          </p>
        </div>
      </div>
      {/* Fragenteil */}
      <div className="container pt-5 my-5">
        <div className="text-center m-4">
          <h2>Überprüfe dein Wissen</h2>
          <p className="col-lg-11 mx-auto">
            Mit den richtigen Antworten kommst du weiter!
          </p>
        </div>
        <div className="row justify-content-center">
          <div className="col-md-12 text-start">
            <form onSubmit={handleSubmit}>
              {questions.map((question, index) => (
                <div key={index} className="mb-4">
                  <p className="fs-4">{question.question}</p>{" "}
                  {question.options.map((option) => (
                    <div key={option.value} className="form-check">
                      <input
                        className="form-check-input me-2"
                        type="radio"
                        name={`question${index}`}
                        value={option.value}
                        checked={selectedAnswers[index] === option.value}
                        onChange={() => handleAnswerChange(index, option.value)}
                      />
                      <label className="form-check-label fs-5">
                        {option.label}
                      </label>{" "}
                    </div>
                  ))}
                </div>
              ))}
              {error && <p className="text-danger">{error}</p>}
              <div className="text-center">
                <button type="submit" className="btn btn-primary">
                  überprüfen
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* Ende Fragenteil */}
    </div>
  );
};

export default Chapter2_1;
